import React, { useMemo } from 'react';
import { getRoute, extra, currentEntity } from 'components/Shortcuts';
import { useSelector } from 'react-redux';
import NavigationCard from 'views/Payments/components/NavigationCard';
import { selectClasificadoresDeTiposDeCargos } from 'store/catalogos';

const PaymentsList = () => {
  const _clasificadores = useSelector(selectClasificadoresDeTiposDeCargos);

  const clasificadores = useMemo(() => {
    if (!_clasificadores) return [];

    const lista = _clasificadores.clasificadores || [];
    if (currentEntity.concatExtra) {
      return [...lista, ...extra()];
    }
    return lista;
  }, [_clasificadores]);

  useMemo(() => {
    localStorage.setItem('clasificadoresLen', clasificadores.length);
  }, [clasificadores.length]);

  if (!clasificadores.length) return null;

  return (
    <>
      {clasificadores.map(({ id, nombre, icono }) => (
        <NavigationCard
          key={id}
          text={nombre}
          to={getRoute({ id, nombre, icono })}
          type={currentEntity.styleClasificador}
          icon={icono}
        />
      ))}
    </>
  );
};

export default PaymentsList;
